import { Injectable } from '@angular/core';
import { PdfGlyphsService } from '@otas/utils/pdf-glyphs/pdf-glyphs.service';
import { AlignmentDetail } from '@otas/model/invoice/invoice-conguration';
// import 'assets/js/default_vfs.js';
// import 'jspdf-customfonts/dist/jspdf.customfonts.min.js';
// import 'assets/js/jspdf_plugin.js';
import { CurrentUser } from '@otas/model/current-user';
import { NotoSansMalayalamBase64 } from './notoFont';
declare let jsPDF: any;
  

@Injectable()
export class PdfGeneratorService {

    constructor(private pdfGlyphsService: PdfGlyphsService) { }
    /**
     * to generate invoice demo for 6x4 plain and a4using jsPDF
     * returns jsPDF instance
     * @param width must be in inches
     * @param height must be in inches
     */
    generatePlainPdfDemoInvoice(width: number, height: number) {
        const orientation = height > width ? 'p' : 'l';
        const doc = new jsPDF(orientation, 'pt', [width * 72, height * 72]);

        // Update font loading
        doc.addFont('Manjari-Bold.ttf', 'Manjari', 'bold');
        doc.setFont('Manjari', 'bold');

        doc.setDrawColor(255, 102, 0);
        doc.roundedRect(15, 10, 335, 45, 3, 3);
        doc.setFontSize(10);

        doc.setTextColor(255, 102, 0);
        doc.text('MAHADEVAGURU TEMPLE', 80, 21);
        doc.text('jk', 80, 31);
        
        // Replace setFontType with setFont
        doc.setFont('Manjari', 'normal');
        doc.setFontSize(8);
        doc.text('vadasserikkonam po,pin:695143,varkala,rhiruvananthapuram', 80, 40);
        doc.text('vadasserikkonam po,pin:695143,varkala,rhiruvananthapuram', 80, 50);

        doc.setFillColor(255, 102, 0);
        doc.roundedRect(15, 55, 335, 18, 3, 3, 'F');
        doc.setFontSize(10);
        // doc.setFont('times');
        // doc.setFontType('bold');
        doc.setTextColor(255, 255, 255);
        doc.text(170, 67, 'Vazhipad Reciept');
        doc.setDrawColor(255, 102, 0);
        doc.roundedRect(15, 73.5, 335, 40, 3, 3);
        doc.setTextColor(255, 102, 0);
        // doc.setFontType('bold');
        doc.setFontSize(9);
        doc.text(20, 110, 'Vazhipad :');
        doc.setTextColor(0, 0, 0);
        // console.log(doc.getFontList());
        // doc.setFontType('normal');
        doc.text(65, 110, this.pdfGlyphsService.glyphCorrection('ഗണപതിഹോമം'));
        // doc.setFont('times');
        doc.setFontType('normal');
        doc.setTextColor(255, 102, 0);
        doc.text(250, 90, 'Date :');
        doc.setTextColor(0, 0, 0);

        doc.text(280, 90, '28/06/2018');
        doc.setTextColor(255, 102, 0);
        doc.text(250, 110, 'Number :');
        doc.setTextColor(0, 0, 0);
        doc.text(285, 110, 'INV-078954');
        doc.setTextColor(255, 102, 0);
        doc.setFillColor(255, 247, 230);
        doc.roundedRect(15, 116, 180, 20, 3, 3, 'FD');
        doc.text(90, 130, 'name');
        doc.setFillColor(255, 247, 230);
        doc.roundedRect(198, 116, 100, 20, 3, 3, 'FD');

        doc.text(240, 130, 'star');
        doc.setFillColor(255, 247, 230);
        doc.roundedRect(300, 116, 50, 20, 3, 3, 'FD');
        doc.text(310, 130, 'amount');
        doc.roundedRect(15, 138, 180, 80, 3, 3);
        doc.setTextColor(0, 0, 0);
        doc.text(30, 152, 'Raju');
        doc.text(30, 164, 'Manu');
        doc.text(30, 176, 'Ram');
        doc.text(30, 188, 'Rajashekara Mannadiar');
        doc.text(30, 200, 'Rajashekar Mannadiar');

        doc.roundedRect(198, 138, 100, 80, 3, 3);
        doc.text(210, 152, 'Aswathi');
        doc.text(210, 164, 'Bharani');
        doc.text(210, 176, 'Karthika');
        doc.text(210, 188, 'Rohini');
        doc.text(210, 200, 'MAkayiram');
        doc.roundedRect(300, 138, 50, 80, 3, 3);
        doc.text(315, 152, '12');
        doc.text(315, 164, '24');
        doc.text(315, 176, '48');
        doc.text(315, 188, '60');
        doc.text(315, 200, '36');
        doc.setTextColor(255, 102, 0);
        doc.text(15, 240, 'manager/secretary');
        doc.text(240, 240, 'total amount');
        doc.setTextColor(0, 0, 0);

        doc.text(315, 240, '180');
        doc.setTextColor(255, 102, 0);

        doc.roundedRect(15, 250, 335, 20, 3, 3);
        doc.text(18, 264, 'vazhipad date : ');
        doc.setTextColor(0, 0, 0);

        doc.text(75, 264, '29/06/2018');
        doc.setTextColor(255, 102, 0);
        return doc;
    }
    generateUserDefinedInvoice(invConfigs: { invoiceAlignments: AlignmentDetail[], details: any[] }) {
        const invoiceAlignments = invConfigs.invoiceAlignments;
        const height = invoiceAlignments[0].height;
        const width = invoiceAlignments[0].width;
        const orientation = height > width ? 'p' : 'l';
        const doc = new jsPDF(orientation, 'pt', [width * 72, height * 72]);
        
        // Update font loading
        doc.addFont('assets/fonts/malayalam/NotoSansMalayalam-Regular.ttf', 'NotoSansMalayalam', 'normal');
        doc.setFont('NotoSansMalayalam', 'normal');
        doc.setFontSize(9);

        invoiceAlignments.forEach((invoiceAlignment, k) => {
            for (let i = 1; i <= 5; i++) {
                // console.log(invoiceAlignment['label' + i]);
                doc.text(invoiceAlignment['x' + i], invoiceAlignment['y' + i],
                    this.pdfGlyphsService.glyphCorrection(invoiceAlignment['label' + i] + ''));

            }
            let nextRow = 152;
            invConfigs.details[k].forEach((el) => {

                // console.log(el);

                doc.text(30, nextRow, this.pdfGlyphsService.glyphCorrection(el.devoteeName));
                doc.text(210, nextRow, this.pdfGlyphsService.glyphCorrection(el.devoteeStar ? el.devoteeStar : '-'));
                doc.text(315, nextRow, el.rate + '');
                nextRow += 12;
            });



            // doc.autoTable(columns, rows, { startY: 14, theme: 'plain' });
            if (invoiceAlignments.length > 1 && k < invoiceAlignments.length - 1) {
                doc.addPage(width * 72, height * 72);
            }
        });
        return doc;

    }
    generateCustomInvoice(formData: any, labels: string[]) {
        
        const currentUser: CurrentUser = JSON.parse(sessionStorage.getItem('CURRENT_USER'));
        const width = +formData['width'];
        const height = +formData['height'];
        const orientation = height > width ? 'p' : 'l';
        
        const doc = new jsPDF(orientation, 'pt', [width * 72, height * 72]);
        const actualWidth = (width * 72);
        const actualHeight = (height * 72);
        const rectWidth = actualWidth - 30;
        const ddRectH = (actualHeight - 216);
        const nameRW = (rectWidth / 2);
        const starRW = (rectWidth / 4);
        const amtRW = (rectWidth / 4);
        const starRX = 15 + nameRW;
        const amtRX = starRX + starRW;
        const nameTX = nameRW / 2;
        const starTX = starRX + (starRW / 3);
        const amtTX = amtRX + (amtRW / 3);
        
        // Update font loading
        doc.addFileToVFS('NotoSansMalayalam-Regular.ttf', NotoSansMalayalamBase64);
        doc.addFont('NotoSansMalayalam-Regular.ttf', 'NotoSansMalayalam', 'normal');
        doc.setFont('NotoSansMalayalam', 'normal');
        
        doc.setDrawColor(255, 102, 0);
        doc.roundedRect(15, 10, rectWidth, 45, 3, 3);
        doc.setFontSize(10);
        doc.setTextColor(255, 102, 0);
        doc.text(this.pdfGlyphsService.glyphCorrection(currentUser.templName.toUpperCase()), rectWidth / 4, 21);

        // Replace setFontType with setFont
        doc.setFont('NotoSansMalayalam', 'normal');
        doc.setFontSize(8);
        doc.text((rectWidth / 4), 40, this.pdfGlyphsService.glyphCorrection(currentUser.templeAddress));
        doc.text((rectWidth / 4), 50, this.pdfGlyphsService.glyphCorrection(currentUser.templeAddress));

        doc.setFillColor(255, 102, 0);
        doc.roundedRect(15, 55, rectWidth, 18, 3, 3, 'F');

        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text((rectWidth / 2) - 20, 67, this.pdfGlyphsService.glyphCorrection('വഴിപാട് രസീത്'));
        doc.setDrawColor(255, 102, 0);
        doc.roundedRect(15, 73.5, rectWidth, 40, 3, 3);
        doc.setTextColor(255, 102, 0);
        doc.setFontSize(8);
        doc.text(20, 110, this.pdfGlyphsService.glyphCorrection('വഴിപാട് :'));
        doc.text(amtRX, 90, this.pdfGlyphsService.glyphCorrection('തിയ്യതി :'));

        doc.text(amtRX, 110, this.pdfGlyphsService.glyphCorrection('നമ്പര്‍ :'));

        doc.setTextColor(0, 0, 0);
        labels.forEach(label => {
            doc.setFontSize(+formData[label].fontSize);
            doc.text((+formData[label].paperX),
                (+formData[label].paperY), this.pdfGlyphsService.glyphCorrection(formData[label].testValue));
        });
        doc.setTextColor(255, 102, 0);
        doc.setFontSize(10);
        doc.setFillColor(255, 247, 230);


        doc.roundedRect(15, 116, nameRW, 20, 3, 3, 'FD');
        doc.text(nameTX, 130, this.pdfGlyphsService.glyphCorrection('പേര്'));
        doc.setFillColor(255, 247, 230);
        doc.roundedRect(starRX, 116, starRW, 20, 3, 3, 'FD');
        doc.text(starTX, 130, this.pdfGlyphsService.glyphCorrection('നക്ഷത്രം'));
        doc.setFillColor(255, 247, 230);
        doc.roundedRect(amtRX, 116, amtRW, 20, 3, 3, 'FD');
        doc.text(amtTX, 130, this.pdfGlyphsService.glyphCorrection('തുക'));

        doc.roundedRect(15, 138, nameRW, ddRectH, 3, 3);
        doc.roundedRect(starRX, 138, starRW, ddRectH, 3, 3);
        doc.roundedRect(amtRX, 138, amtRW, ddRectH, 3, 3);
        const mnY = 168 + ddRectH;
        doc.text(15, mnY, this.pdfGlyphsService.glyphCorrection('മാനേജർ/സെക്രട്ടറി'));
        doc.text(starTX, mnY, this.pdfGlyphsService.glyphCorrection('ആകെ തുക'));
        doc.roundedRect(15, mnY + 10, rectWidth, 20, 3, 3);
        doc.text(18, mnY + 24, this.pdfGlyphsService.glyphCorrection('വഴിപാട് തിയ്യതി : '));
        return doc;
    }
}
